import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Tooltip } from 'next-common-lib';
import i18n from 'i18n';
import DeleteButton from 'components/Common/Buttons/DeleteButton';
import * as pimsActions from 'redux/ducks/Anniversary/AnniversaryDucks';
import * as wizardActions from 'redux/ducks/common/wizardDuck';

export const InputAnniversary = () => {
  const dispatch = useDispatch();
  const anniversary = useSelector(state => state.anniversary);
  const rescurrenceText = recurrence => {
    return recurrence === 'Y' ? 'color-warning' : '';
  };

  return (
    <>
      <Button
        componentType="normal"
        label={i18n.t('BTY_W_T_ADD_ANNIVERSARY_INFO')}
        className="add"
        iconInfo={{ className: 'ic-plus ', size: 'sm' }}
        disabled={anniversary.anniversaryList?.length === 3}
        tabIndex={0}
        onClick={() => {
          dispatch(wizardActions.openPopup({}));
        }}
      />

      {anniversary.anniversaryList?.map(item => {
        return (
          <div className="view-box board" key={item.uid}>
            <Tooltip componentType="move" label={[`${item.subject}`]} placement="bottom">
              <div className="view-box-content">
                <p className="main-text">{item.subject}</p>
                <p className={`main-text ${rescurrenceText(item.restDayYn)}`}>{item.startTime}</p>
              </div>
            </Tooltip>
            {!!item.recurrence && (
              <div className="home">
                <p className="tiny-text">{i18n.t('BTY_W_T_RECURRENCE')}</p>
              </div>
            )}
            <DeleteButton
              handleOnclick={() =>
                dispatch(
                  pimsActions.deleteHoliday({
                    code: anniversary.subscribedId,
                    uid: item.uid,
                  }),
                )
              }
            />
          </div>
        );
      })}
    </>
  );
};

InputAnniversary.propTypes = {};
InputAnniversary.defaultProps = {};
export default InputAnniversary;
